export default (base) => {
  return {
    SortableReference (field, visible, sortField = field + 'SearchRep', plain = false) {
      return {
        label: `${base}.list.column.${field}`,
        field,
        sortField,
        render: 'stringRep',
        tableVisible: visible,
        sortable: true,
        plain
      }
    },

    UnsortableReference (field, visible, plain = false) {
      return {
        label: `${base}.list.column.${field}`,
        field,
        render: 'stringRep',
        tableVisible: visible,
        plain
      }
    },

    SortableField (field, visible, type = 'string', sortField = field) {
      return {
        label: `${base}.list.column.${field}`,
        field,
        tableVisible: visible,
        sortable: true,
        sortField,
        type
      }
    },

    SortableBoolean (field, visible) {
      return {
        label: `${base}.list.column.${field}`,
        field,
        tableVisible: visible,
        sortable: true,
        type: Boolean
      }
    },

    SortableDate (field, visible) {
      return {
        label: `${base}.list.column.${field}`,
        field,
        tableVisible: visible,
        sortable: true,
        type: Date
      }
    },

    SortableTimestamp (field, visible, sortField = field, asDate = false) {
      return {
        label: `${base}.list.column.${field}`,
        field,
        tableVisible: visible,
        sortable: true,
        sortField,
        type: asDate ? 'timestampAsDate' : 'timestamp'
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/schema/list/ListFieldsGeneric.js